export const multiselectAction = (node,config)=>{
   $(node).multiselect(config)
    return {

        update: (data)=>{
            $(node).multiselect("destroy")
            $(node).multiselect(config)
        },
        destroy:()=>{
            $(node).multiselect("destroy")
        }
    }
}